export default function HighlightText({ text, search }: { text: string; search: string }) {
    if (!search?.trim() || !text) return <>{text || "---"}</>;
    const searchLower = search.toLowerCase().trim();
    const result: React.JSX.Element[] = [];
    let searchIndex = 0;
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (searchIndex < searchLower.length && char.toLowerCase() === searchLower[searchIndex]) {
            result.push(<span key={i} className="font-bold text-slate-900">{char}</span>);
            searchIndex++;
        } else {
            result.push(<span key={i}>{char}</span>);
        }
    }
    return <>{result}</>;
};